import { render } from "./CustomMessage.vue?vue&type=template&id=10d65a0c&scoped=true"
import script from "./CustomMessage.vue?vue&type=script&lang=js"
export * from "./CustomMessage.vue?vue&type=script&lang=js"

import "./CustomMessage.vue?vue&type=style&index=0&id=10d65a0c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d65a0c"]])

export default __exports__